declare global {
  interface Window {
    plausible: any
  }
}

if (typeof window !== 'undefined') {
  window.plausible =
    window.plausible ||
    function (...args: any) {
      ;(window.plausible.q = window.plausible.q || []).push(args)
    }
}

export const trackGoal = (goal: string, props?: { props: object }): void => {
  if (window.plausible) {
    window.plausible(goal, props)
  }
}
